import { Link } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';

type ReportPageLinksProps = {
  sibling?: { slug: string; label: string };
};

export function ReportPageLinks({ sibling }: ReportPageLinksProps) {
  const { basePath } = usePortal();
  const home = basePath || '/report';

  return (
    <>
      <Link to={home} className="btn-secondary btn-sm">
        All reports
      </Link>
      {sibling ? (
        <Link to={`${home}/${sibling.slug}`} className="btn-secondary btn-sm">
          {sibling.label}
        </Link>
      ) : null}
    </>
  );
}
